import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { AssetProvider } from '../../providers/asset/asset';
import { Asset } from '../../interfaces/asset.model';
import { Keyword } from '../../interfaces/keyword.model';
import { KeywordProvider } from '../../providers/keyword/keyword';
import { StorageProvider } from '../../providers/storage/storage';

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {

  @ViewChild('fixed') mapElement: ElementRef;
  @ViewChild('scrollContent') scrollContent: ElementRef;
  @ViewChild('myHeader') ionHeader: ElementRef;

  fixedheight: any;

  assets: Asset[];
  allAssets: Asset[];
  keywords: Keyword[];
  allKeywords: Keyword[];
  searchAsset: string;
  searchKeyword: string;
  selectedKeywords: Keyword[];
  displayAsList: boolean;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public assetService: AssetProvider,
    public storageService: StorageProvider,
    public keywordService: KeywordProvider,
    public translate: TranslateService) 
  {
      this.keywords = [];
      this.assets = [];
      this.searchAsset = "";
      this.searchKeyword = "";
      this.selectedKeywords = [];
  }

  ionViewDidLoad() {
    this.getKeywords();
    this.getAssets();
    this.getDisplayListView();
  }

  ionViewDidEnter(){
    //this.setFixedHeight();
  }

  setFixedHeight(){
    this.fixedheight = this.mapElement.nativeElement.offsetHeight;
    let scroll = this.scrollContent.nativeElement.parentElement;
    let headerHeight = this.ionHeader.nativeElement.offsetHeight;

    scroll.style.marginTop = headerHeight + this.fixedheight + 'px';
  }

  getAssets(){
    return this.assetService.getAssets().then(assets => this.allAssets = assets);
  }

  getKeywords(){
    return this.keywordService.getKeywords().then(keywords => {
      this.allKeywords = keywords;
      this.keywords = keywords;
    });
  }

  /* LIST VIEW */

  getDisplayListView(){
    this.storageService.getDataStorage("displayAsList").then(displayListView => {
      if(displayListView !== null){
        this.displayAsList = displayListView;
      } else {
        this.displayAsList = false;
      }
    });
  }

  updateListView(){
    this.displayAsList = !this.displayAsList;
    this.storageService.setDataStorage("displayAsList", this.displayAsList);
  }

  searchQueryAsset(){
      if ((this.searchAsset && (this.searchAsset.trim() !== '') && (this.searchAsset.trim().length > 2)) || this.selectedKeywords.length > 0) {
        const searchWord = this.searchAsset.toLowerCase();

        this.assets = this.allAssets.filter(asset => {
          return (
            (asset.AssetName.toLowerCase().indexOf(searchWord) !== -1 
            || asset.AssetFile.toLowerCase().indexOf(searchWord) !== -1)
            && this.selectedKeywords.every(selectKeyword => asset.Keyword.some(keyword => keyword.KeywordId == selectKeyword.KeywordId))
          );
        })
      } else {
        this.assets = [];
      }
  }

  addKeyword(keyword){
    if(!this.hasAlreadyKeyword(keyword.KeywordId)){
      this.selectedKeywords.push(keyword);
      this.searchQueryAsset();
      setTimeout(() => {
        this.setFixedHeight();
      }, 300);
    }
  }

  deleteKeyword(keywordId){
    let found = this.selectedKeywords.findIndex(keyword => keyword.KeywordId == keywordId)
    if(found !== -1){
      this.selectedKeywords.splice(found, 1);
      this.searchQueryAsset();
      setTimeout(() => {
        this.setFixedHeight();
      }, 300);
    }
  }

  hasAlreadyKeyword(keywordId){
    return this.selectedKeywords.some(item => item.KeywordId == keywordId);
  }

  searchQueryKeyword(){
      if (this.searchKeyword && this.searchKeyword.trim() !== '') {
        const searchWord = this.searchKeyword.toLowerCase();
        this.keywords = this.allKeywords.filter(keyword => {
          return (keyword.KeywordName.toLowerCase().indexOf(searchWord) !== -1);
        })
      } else {
        this.keywords = this.allKeywords;
      }
  }

  setActiveClass(){

  }

}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts